import React, {  Component } from 'react';

export default class ToolTipOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('ToolTipOverlayDialog', false);
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="actionDescriptionsOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">{this.props.title}</h2>
                    <div className="scroll-height-action-description">
    					<table className="dataTable">
    						<tbody>
    							<tr>
    								<td> 
                                    <div dangerouslySetInnerHTML={{ __html: this.props.content }} />
                                        </td></tr>
    						</tbody>
    					</table>
                    </div>
            	</div>
			</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/toolTipOverlayDialog.js